import React, { FC } from 'react';
import { UserCoursesUpcomingContent } from 'src/user/courses/components/UserCoursesUpcoming/UserCoursesUpcomingContent';
import { UserCoursesUpcomingEmpty } from 'src/user/courses/components/UserCoursesUpcoming/UserCoursesUpcomingEmpty';
import { useCurrentUserIncomingEventsQuery } from 'src/common/hooks/event/useCurrentUserIncomingEventsQuery';
import styled, { css } from 'styled-components';
import { media } from 'src/config/breakpoints';
import { UserCoursesSectionTitle } from 'src/user/courses/components/UserCoursesSectionTitle';
import { UserCoursesSectionHeader } from 'src/user/courses/components/UserCoursesSectionHeader';
import { SimpleLink } from 'src/common/components/SimpleLink';
import { UserCoursesSectionTooltip } from 'src/user/courses/components/UserCoursesSectionTooltip';
import { CourseCardSkeleton } from 'src/common/components/CourseCardSkeleton';

const Container = styled.div`
  padding: 2.5rem 0 0;

  ${media.w.min.px768(css`
    padding-top: 1.875rem;
  `)};
`;

const Text = styled.div`
  margin: 1.25rem 0;
`;

export const UserCoursesUpcoming: FC = () => {
  const {
    data: incomingEvents,
    isLoading,
    isError,
    isSuccess: incomingEventsSuccess,
  } = useCurrentUserIncomingEventsQuery();

  const isEmpty = incomingEventsSuccess && incomingEvents?.length === 0;
  const isSome = incomingEventsSuccess && (incomingEvents?.length ?? 0) > 0;

  return (
    <Container>
      <UserCoursesSectionHeader>
        <UserCoursesSectionTitle>Nadchodzące</UserCoursesSectionTitle>

        {isSome && (
          <UserCoursesSectionTooltip
            kind="external"
            title={
              <>
                Szkolenia odbywają się na aplikacji zoom, <u>pobierz aplikację</u>
              </>
            }
            to="https://zoom.us/download#client_4meeting"
          >
            Szkolenia odbywają się na aplikacji zoom,&nbsp;
            <SimpleLink href="https://zoom.us/download#client_4meeting" target="_blank">
              pobierz aplikację
            </SimpleLink>
          </UserCoursesSectionTooltip>
        )}
      </UserCoursesSectionHeader>

      {isLoading && <CourseCardSkeleton />}
      {isError && <Text>Wystapił błąd podczas pobierania wydarzeń.</Text>}
      {isEmpty && <UserCoursesUpcomingEmpty />}
      {isSome && <UserCoursesUpcomingContent items={incomingEvents!} />}
    </Container>
  );
};
